export const drawerWidth = 232;